<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-book</v-icon>
        <h1 class="title ml-2">Libros de matutina</h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="showNew = true">
              <v-icon left>fas fa-plus</v-icon>
              Agregar
            </v-btn>
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Título</th>
                <th>Tipo</th>
                <th>Imagen</th>
                <th>Año</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in libros" :key="item.id">
                <td>{{item.titulo}}</td>
                <td>{{item.tipo}}</td>
                <td>
                  <v-avatar
                    size="50"
                    tile
                  >
                    <v-img :src="item.img"></v-img>
                  </v-avatar>
                </td>
                <td>{{item.anho}}</td>
                <td class="min-width-120">
                  <v-btn fab text color="secondary" @click="editItem(item)">
                    <v-icon>fas fa-edit</v-icon>
                  </v-btn>
                  <v-btn fab text color="error" @click="deleteItem(item.id)">
                    <v-icon>fas fa-trash</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <!-- ------------------------------------------------------------------- -->
    <!-- New libro -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showNew" max-width="600">
      <edit-libro
        icon="fas fa-plus"
        title="Agregar libro"
        v-model="newLibro"
        @close="showNew = false"
        ref="newLibro"
        @save="saveLibro()"
      ></edit-libro>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- Edit libro -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showEdit" max-width="600">
      <edit-libro
        icon="fas fa-edit"
        title="Modificar libro"
        v-model="editLibro"
        @close="showEdit = false"
        @save="updateLibro()"
      ></edit-libro>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- Loader -->
    <!-- ------------------------------------------------------------------- -->
    <loader v-model="loading"></loader>
  </v-container>
</template>

<script>
import EditLibro from '../components/EditLibro'
import Loader from '../components/Loader'
import { host } from '../config'
export default {
  data () {
    return {
      showNew: false,
      showEdit: false,
      newLibro: {
        titulo: '',
        anho: '',
        tipo: '',
        imagen: null
      },
      editLibro: null,
      libros: [],
      loading: false
    }
  },
  components: {
    EditLibro,
    Loader
  },
  methods: {
    getLibros () {
      this.$http.libros
        .get('')
        .then(res => res.data)
        .then(res => {
          this.libros = res.map(i => {
            return { ...i, img: `${host}${i.imagen.url}` }
          })
        })
    },
    saveLibro () {
      this.loading = true
      if (!this.newLibro.imagen) {
        this.$http.libros
          .post('', this.newLibro)
          .then(() => {
            this.getLibros()
            this.$refs['newLibro'].reset()
            this.showNew = false
            this.loading = false
          })
      } else {
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
        const { imagen, ...data } = this.newLibro
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))
        formData.append('files.imagen', imagen, imagen.name)
        this.$http.libros
          .post('', formData, config)
          .then(() => {
            this.getLibros()
            this.$refs['newLibro'].reset()
            this.showNew = false
            this.loading = false
          })
      }
    },
    updateLibro () {
      this.loading = true
      if (this.editLibro.imagen instanceof File) {
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
        const { imagen, ...data } = this.editLibro
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))
        formData.append('files.imagen', imagen, imagen.name)
        this.$http.libros
          .put(`/${this.editLibro.id}`, formData, config)
          .then(() => {
            this.getLibros()
            this.showUpdate = false
            this.loading = false
          })
      } else {
        this.$http.libros
          .put(`/${this.editLibro.id}`, this.editLibro)
          .then(() => {
            this.getLibros()
            this.showUpdate = false
            this.loading = false
          })
      }
    },
    editItem (item) {
      this.editLibro = item
      this.showEdit = true
    },
    deleteItem (id) {
      if (window.confirm('¿Estas seguro de borrar el registro?')) {
        this.$http.libros
          .delete(`/${id}`)
          .then(() => {
            this.getLibros()
          })
      }
    }
  },
  mounted () {
    this.getLibros()
  }
}
</script>
